import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  z-index: ",
        ";\n  background-color: ",
        ";\n  color: white;\n  margin: 0;\n  padding: 8px 0;\n  position: absolute;\n  right: ",
        ";\n  top: 0;\n  text-align: center;\n  transform: ",
        ";\n  transform-origin: top left;\n  width: 96px;\n\n  &:before,\n  &:after {\n    background-color: ",
        ';\n    content: "";\n    height: 100%;\n    margin: 0 -1px; /* Removes tiny gap */\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  &:before {\n    right: 100%;\n  }\n\n  &:after {\n    left: 100%;\n  }\n\n  & > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 96px;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var StyledCardRibbon = styled.div.withConfig({
    componentId: "sc-e1bdbf71-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.zIndices.ribbon;
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? 0 : "auto";
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? "translateX(30%) translateY(0%) rotate(45deg)" : "translateX(0%) translateY(200%) rotate(-45deg)";
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
});
var CardRibbon = function(_param) {
    var variantColor = _param.variantColor, text = _param.text, ribbonPosition = _param.ribbonPosition, props = _object_without_properties(_param, [
        "variantColor",
        "text",
        "ribbonPosition"
    ]);
    return /*#__PURE__*/ _jsx(StyledCardRibbon, _object_spread_props(_object_spread({
        variantColor: variantColor,
        ribbonPosition: ribbonPosition
    }, props), {
        children: /*#__PURE__*/ _jsx("div", {
            title: text,
            children: text
        })
    }));
};
CardRibbon.defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    ribbonPosition: "right"
};
export default CardRibbon;
